module.exports = __webpack_public_path__ + "media/images/back_invoice_210mm_cmyk-ab19c549.jpg";